import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function Book({data}) {
    const {bookEmail, bookEmailButtonText, bookInstagramButtonText, bookInstagramLink, bookLinkedinButtonText, bookLinkedinLink, bookText, bookTitle, bookImage} = data
    return (
        <div className='image-radius-pattern-2 dana-profile-sec light-grey-bg'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                        <div className='image-r-patrn-2 img-green-bg-1 hide-mobile'>
                            <GatsbyImage
                                image={getImage(bookImage?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                    <div className='col-md-7'>
                        <h2 className='heading-level-2-i blue-color text-uppercase'>
                            {bookTitle && parser(bookTitle)}
                        </h2>
                        <p>{bookText && parser(bookText)}</p>
                        <div className='image-r-patrn-2 img-green-bg-1 hide-desk'>
                            <GatsbyImage
                                image={getImage(bookImage?.localFile)}
                                alt='image'
                            />
                        </div>
                        <p className='mb-0 ids-text'>
                            <StaticImage
                                src='../../../images/email.svg'
                                className='email-id-icon'
                                alt='image'
                            />
                            <strong>Email: </strong>
                            {bookEmail && (
                                <a href={`mailto:${bookEmail}`}>{bookEmailButtonText}</a>
                            )}
                        </p>
                        <p className='mb-0 ids-text'>
                            <StaticImage
                                src='../../../images/in-b.svg'
                                className='email-id-icon'
                                alt='image'
                            />
                            <strong>LinkedIn: </strong>
                            {bookLinkedinLink && (
                                <Link to={bookLinkedinLink}>{bookLinkedinButtonText}</Link>
                            )}
                        </p>
                        <p className='mb-0 ids-text'>
                            <StaticImage
                                src='../../../images/ig.svg'
                                className='ig-id-icon'
                                alt='image'
                            />
                            <strong>Instagram: </strong>
                            {bookInstagramLink && (
                                <Link to={bookInstagramLink}>{bookInstagramButtonText}</Link>
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
